'use strict';

exports.__esModule = true;
var SCHEDULES = exports.SCHEDULES = {
  LOADING: 'LOADING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
};

var VEZEETA_SCHEDULE = exports.VEZEETA_SCHEDULE = {
  FETCH: 'VEZEETA_SCHEDULE_FETCH',
  SUCCEEDED: 'VEZEETA_SCHEDULE_SUCCEEDED',
  FAILED: 'VEZEETA_SCHEDULE_FAILED'
};

var loadSchedules = exports.loadSchedules = function loadSchedules() {
  return {
    type: SCHEDULES.LOADING
  };
};

var loadSchedulesSucceeded = exports.loadSchedulesSucceeded = function loadSchedulesSucceeded(schedules) {
  return {
    type: SCHEDULES.SUCCEEDED,
    schedules: schedules
  };
};

var loadSchedulesFailed = exports.loadSchedulesFailed = function loadSchedulesFailed(error) {
  return {
    type: SCHEDULES.FAILED,
    error: error
  };
};

var getVezeetaSchedules = exports.getVezeetaSchedules = function getVezeetaSchedules(payload) {
  return {
    type: VEZEETA_SCHEDULE.FETCH,
    payload: payload
  };
};

var getVezeetaSchedulesSucceeded = exports.getVezeetaSchedulesSucceeded = function getVezeetaSchedulesSucceeded(payload) {
  return {
    type: VEZEETA_SCHEDULE.SUCCEEDED,
    payload: payload
  };
};

var getVezeetaSchedulesFailed = exports.getVezeetaSchedulesFailed = function getVezeetaSchedulesFailed(payload) {
  return {
    type: VEZEETA_SCHEDULE.FAILED,
    payload: payload
  };
};